import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';

import Eventos from './components/Eventos';
import Inicio from './components/Inicio';
import EditarEvento from './components/EditarEvento';
import DetalleEvento from './components/DetalleEvento';
import CrearEvento from './components/CrearEvento';
import Inscripciones from './components/Inscripciones';
import EditarInscripcion from './components/EditarInscripcion';
import CrearInscripcion from './components/CrearInscripcion';
import EventoUser from './components/EventoUser';
import Contacto from './components/Contacto';
import Error from './components/Error';
import InscripcionUser from './components/InscripcionUser';
import DetalleEventoUser from './components/DetalleEventoUser';

import Login from './components/authLogin/Login';
import Register from './components/authLogin/Register';
import RecuperarContraseña from './components/authLogin/RecuperarContraseña';
import ContraseñaOlvidada from './components/authLogin/ContraseñaOlvidada';
import ResentMessage from './components/authLogin/ResentMessage';
import VerifyUser from './components/authLogin/VerifyUser';
import CalendarioEventos from './components/CalendarioEventos';

import RutasPrivadas from './RutasPrivadas';
import Unauthorized from './components/Unauthorized';


import Footer from './Footer';
import Navbar from './Navbar';

function App() {
  return (
    <div className="app-wrapper">
      <BrowserRouter>
        <Navbar />
        <main className="main-content">
          <Routes>
            
            <Route path="/" element={<Inicio />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verifyUser/:token" element={<VerifyUser />} />
            <Route path="/recuperarContraseña/:token" element={<RecuperarContraseña />} />
            <Route path="/contraseñaOlvidada" element={<ContraseñaOlvidada />} />
            <Route path="/ResentMessage" element={<ResentMessage />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

           
            <Route path="/eventos" element={
              <RutasPrivadas allowedRoles={['admin']}>
                <Eventos />
              </RutasPrivadas>
            } />
            <Route path="/editarEvento/:id" element={
              <RutasPrivadas allowedRoles={['admin']}>
                <EditarEvento />
              </RutasPrivadas>
            } />
            <Route path="/crearEvento" element={
              <RutasPrivadas allowedRoles={['admin']}>
                <CrearEvento />
              </RutasPrivadas>
            } />
            <Route path="/inscripciones" element={
              <RutasPrivadas allowedRoles={['admin']}>
                <Inscripciones />
              </RutasPrivadas>
            } />
            <Route path="/editarInscripcion/:id" element={
              <RutasPrivadas allowedRoles={['normal', 'admin']}>
                <EditarInscripcion />
              </RutasPrivadas>
            } />
            <Route path="/crearInscripcion" element={
              <RutasPrivadas allowedRoles={['normal', 'admin']}>
                <CrearInscripcion />
              </RutasPrivadas>
            } />
            <Route path="/detalleEvento/:id" element={
              <RutasPrivadas allowedRoles={['admin']}>
                <DetalleEvento />
              </RutasPrivadas>
            } />

            
            <Route path="/eventoUser" element={
              <RutasPrivadas allowedRoles={['normal']}>
                <EventoUser />
              </RutasPrivadas>
            } />
            <Route path="/detalleEventoUser/:id" element={
              <RutasPrivadas allowedRoles={['normal']}>
                <DetalleEventoUser />
              </RutasPrivadas>
            } />
            <Route path="/inscripcionUser" element={
              <RutasPrivadas allowedRoles={['normal']}>
                <InscripcionUser />
              </RutasPrivadas>
            } />

           
            <Route path="/contacto" element={
              <RutasPrivadas allowedRoles={['normal', 'admin']}>
                <Contacto />
              </RutasPrivadas>
            } />
            <Route path="/calendarioEventos" element={
              <RutasPrivadas allowedRoles={['normal', 'admin']}>
                <CalendarioEventos />
              </RutasPrivadas>
            } />

            
            <Route path="*" element={<Error />} />
            <Route path="/unautorized" element={<Unauthorized />} />
             
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
